import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LocaleProvider } from './i18n/LocaleContext';

// A file-input change and React's following state commit are separate steps. On a fast tap,
// the chat form can submit in the tiny gap between them and start an agent task with the text
// but without the image the customer just selected. Keep a short-lived browser-level marker
// from the native event itself, which fires before any submit can race the React render. The
// API layer clears this marker as soon as the image-analysis path has actually taken ownership
// of the file; until then an agent task is refused locally instead of starting without it.
const markPendingImageAttachment = (file, source) => {
  if (!file || !String(file.type || '').startsWith('image/')) return;
  window.__codevoyagePendingImageAttachment = {
    selectedAt: Date.now(),
    name: String(file.name || 'image'),
    source
  };
};

document.addEventListener('change', event => {
  const target = event.target;
  if (target?.type !== 'file') return;
  markPendingImageAttachment(target.files?.[0], 'picker');
}, true);

document.addEventListener('paste', event => {
  const imageItem = Array.from(event.clipboardData?.items || []).find(item => item.kind === 'file' && String(item.type || '').startsWith('image/'));
  if (imageItem) markPendingImageAttachment(imageItem.getAsFile(), 'paste');
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><LocaleProvider><App /></LocaleProvider></React.StrictMode>);

// Registers the passthrough service worker (public/service-worker.js) so the app meets
// PWA "installable" criteria and can actually be added to the home screen - a customer
// otherwise either had no install option or got a plain bookmark shortcut instead of a
// real app icon. Deferred to window 'load' (standard practice, keeps it off the critical
// render path) and wrapped so a registration failure never breaks the app itself.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
